import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = { class: "pulsate" };
const _hoisted_3 = ["innerHTML"];
import { ref, onMounted } from 'vue';
import { useAuth } from '@/composables/useAuth';
import { useContent } from '@/composables/useContent';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PersonalNewsPage',
    setup(__props) {
        useAuth();
        const { getPersonalNews } = useContent();
        const news = ref(null);
        const working = ref(true);
        const loadingMessages = [
            "Reading the latest headlines 🧐 ...",
            'Gathering the latest financial news 📰 ☕...',
            "Looking for updates on your finances 🫣 ...",
            "Checking your insurance policies 💪 ...",
            "Looking at your pensions 🤩 ...",
            "Checking your documents 📑 ...",
            "Gathering the latest news on your investments 🤓 ...",
            "Checking your mortgages 🏠 ...",
            "Checking your bank accounts for the latest transactions 🤑 ...",
            "Checking your spending this week 💸 ...",
            "Studying your spending habits 🤯 ...",
            "Looking for the latest discounts on your shopping 🥳 ...",
            'Creating your personal news feed, this may take a few seconds 🔨 ...',
        ];
        const loadingIndex = ref(1);
        const message = ref("");
        const log = ref("");
        let interval;
        let typeInterval = null;
        const typeMessage = (text) => {
            if (typeInterval)
                clearInterval(typeInterval);
            const chars = Array.from(text);
            message.value = "";
            let i = 0;
            typeInterval = setInterval(() => {
                if (i >= chars.length || !working.value) {
                    if (typeInterval)
                        clearInterval(typeInterval);
                    typeInterval = null;
                    return;
                }
                message.value += chars[i];
                i++;
            }, 40);
        };
        onMounted(() => {
            typeMessage(loadingMessages[0]);
            interval = setInterval(() => {
                if (!working.value) {
                    clearInterval(interval);
                }
                else {
                    typeMessage(loadingMessages[loadingIndex.value]);
                    if (loadingIndex.value > 0) {
                        const toAdd = loadingMessages[loadingIndex.value - 1].replace('...', '') + "\n";
                        if (!log.value.includes(toAdd)) {
                            log.value += toAdd;
                        }
                    }
                    loadingIndex.value = (loadingIndex.value + 1) % loadingMessages.length;
                }
            }, 4000);
            getPersonalNews((res, stillWorking) => {
                if (!stillWorking) {
                    working.value = false;
                    news.value = res;
                    clearInterval(interval);
                    if (typeInterval)
                        clearInterval(typeInterval);
                }
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Your Personal News",
                    bgcolor: "white"
                }),
                (working.value)
                    ? (_openBlock(), _createBlock(_Transition, { key: 0 }, {
                        default: _withCtx(() => [
                            _createElementVNode("p", {
                                innerHTML: log.value.replaceAll('\n', '<br/>')
                            }, null, 8, _hoisted_1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (working.value)
                    ? (_openBlock(), _createBlock(_Transition, { key: 1 }, {
                        default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_2, _toDisplayString(message.value), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (news.value)
                    ? (_openBlock(), _createBlock(_Transition, { key: 2 }, {
                        default: _withCtx(() => [
                            _createElementVNode("p", {
                                innerHTML: news.value.replaceAll('\n', '<br/>')
                            }, null, 8, _hoisted_3)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createElementVNode("div", { style: { "height": "30px" } }, null, -1))
            ], 64));
        };
    }
});
